import axios from "axios";
import qs from "qs";
import { WiGuardian } from "../../../services/WiMuleSQL";
import { DEFAULT_PROJECT, DEFAULT_MAX_COUNTER, normalizeLac } from "../settings";

export const buildExtendedDirectoryParams = ({
  project = DEFAULT_PROJECT,
  gc,
  maxCounter = DEFAULT_MAX_COUNTER,
  lac,
  pos,
} = {}) => ({
  project,
  gc,
  maxCounter,
  lac: normalizeLac(lac) ?? undefined, // undefined means “don’t send”
  pos: pos?.trim() || undefined,
});

export const fetchExtendedDirectoryByLocation = async ({ signal, ...input } = {}) => {
  const params = buildExtendedDirectoryParams(input);


  const res = await axios.get(
    `${WiGuardian}/api/Urd/GetExtendedDirectoryByLocation`,
    {
      params,
      paramsSerializer: (params) =>
        qs.stringify(params, { arrayFormat: "repeat" }), // lac=02&lac=03
      signal,
    }
  )

  var resurl =  `${WiGuardian}/api/Urd/GetExtendedDirectoryByLocation`

  console.log("URL", resurl)


  if (!res.data?.success) throw new Error(res.data?.message ?? "Request failed");
  return res.data.data;
};

